import UserStats from './UserStatsPage';

export default UserStats;
